const ColorFilter = {
  data() {
    return {
      activeColors: this.activeItems
    }
  },
  props: [
    'activeItems'
  ],
  watch: {
    activeItems(newValue) {
      this.activeColors = newValue
    }
  },
  methods: {
    handleInput: function(event) {
      bus.$emit('color_filter', event.target.value)
    },
  }
}

export default ColorFilter
